import {ChangeDetectionStrategy, Component, inject, Signal} from '@angular/core';
import {takeUntil} from 'rxjs/operators';
import {destroy$} from '../../components/destroyable';
import {ComputedLp} from '../../components/dex/dex-streaming/types/computed/computed-lp';
import {ComputedTranche} from '../../components/dex/dex-streaming/types/computed/computed-tranche';
import {Widget} from '../../components/layout/widget/widget';
import {WidgetLinkingGroupService} from '../../components/widget-linking-group/index';
import {DexLpWidget} from './dex-lp-widget';
import {DexLpWidgetImplementation} from './dex-lp-widget.implementation';

@Component({
    selector:        'dex-lp-widget',
    templateUrl:     './dex-lp-widget.component.html',
    styleUrls:       ['./dex-lp-widget.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone:      false
})
export class DexLpWidgetComponent {

    public readonly widget = inject(Widget) as DexLpWidget;
    public readonly widgetImpl: DexLpWidgetImplementation = this.widget.implementationInstance;

    public readonly lp: Signal<ComputedLp> = this.widgetImpl.$lp;
    public readonly traches: Signal<ComputedTranche[]> = this.widgetImpl.$traches;

    private readonly destroy$ = destroy$();

    private readonly widgetLinkingGroupService = inject(WidgetLinkingGroupService);

    public handleToggleCollapsed(isLp: boolean, symbol: string): void {
        this.widgetImpl.updateSettings({
            expandedSymbol: isLp ? undefined : symbol
        }).pipe(
            takeUntil(this.destroy$)
        ).subscribe();
    }

    public handleSymbolClick(symbol: string): void {
        this.widgetLinkingGroupService.setLinkingGroupSettings(
            this.widget.linkingGroupId,
            this.widget.tabId,
            {
                trancheSymbol: symbol
            } as any
        );
    }

}
